import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=7df45830&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=7df45830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df45830",
  null
  
)

export default component.exports